module.exports = __webpack_public_path__ + "static/img/ms-workbench.e66e1b4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/20250724/ruanjian/ms-workbench.svg
// module id = XuG4
// module chunks = 28